export default __webpack_public_path__ + "static/media/titulo_peru.4eb45096.png";